export default "__VITE_ASSET__DOJ7qKPz__"